import { buildCreateSlice, asyncThunkCreator } from '@reduxjs/toolkit';

import { initialState } from './initial';
import { reducers } from './reducers';

export const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export const templatesSlice = createAppSlice({
  name: 'templates',
  initialState,
  reducers,
});

export const {
  fetchThemePacks,
  saveThemePack,
  createThemePack,
  fetchThemesAndTemplates,
  fetchTemplateFilters,
  fetchUserTemplateFavorites,
  deleteUserTemplateFavorite,
  addUserTemplateFavorite,
  updateRefetchTemplatesCounter,
  clearTemplatesList,
  setTemplateFiltersInStoreOnly,
  appendNewTheme,
  updateTheme,
  fetchFontPacks,
  updateFontPacks,
  deleteThemePackSync,
} = templatesSlice.actions;

export default templatesSlice.reducer;
